(() => {
  /* Swap tank PDP (product.swap-tank). The buy box on this page is the homepage offer section
     (susies-swap-offer), so the st6 bundle script (susies-comfort-pdp-bundles.js) is not loaded: it
     needs the old st6 form. This file keeps the parts of it the rest of the page uses, copied as is:
     the size guide dialog, the review videos and the reviews strip. */
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    let trigger;
    const openDialog = (dialog, button) => { if (!dialog) return; trigger = button; dialog.showModal(); document.documentElement.style.overflow = 'hidden'; };
    root.querySelectorAll('[data-size-open]').forEach(b => b.addEventListener('click', () => openDialog(root.querySelector('.ss-size-dialog'), b)));
    root.querySelectorAll('dialog').forEach(d => {
      d.querySelector('[data-dialog-close]')?.addEventListener('click', () => d.close());
      d.addEventListener('click', e => { if (e.target === d) { const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close(); } });
      d.addEventListener('close', () => { document.documentElement.style.overflow = ''; trigger?.focus({preventScroll: true}); });
    });

    // "Get My Tanks" buttons scroll up to the offer box
    const offer = document.getElementById('swap-offer');
    if (offer) offer.style.scrollMarginTop = '24px';

    // Media is loaded and played only while visible. No native video chrome.
    const videos = [...root.querySelectorAll('[data-video-src]')];
    function syncSound(video) {
      const button = video.parentElement.querySelector('[data-video-sound]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute('aria-label', (video.muted ? 'Unmute ' : 'Mute ') + button.dataset.name + "'s video");
    }
    function playVisible(video) {
      if (!video.src) video.src = video.dataset.videoSrc;
      video.play().catch(() => { /* The audio button also retries browser-blocked playback. */ });
    }
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        video.dataset.visible = String(entry.isIntersecting);
        if (entry.isIntersecting && !document.hidden) playVisible(video);
        else video.pause();
      });
    }, {threshold: 0.2});
    videos.forEach(video => {
      video.muted = true;
      videoObserver.observe(video);
      video.addEventListener('volumechange', () => syncSound(video));
      video.parentElement.querySelector('[data-video-sound]')?.addEventListener('click', () => {
        const unmute = video.muted;
        videos.forEach(other => { if (other !== video) other.muted = true; });
        video.muted = !unmute;
        syncSound(video);
        playVisible(video);
      });
    });
    const videoRail = root.querySelector('.ss-video-grid');
    root.querySelectorAll('[data-video-step]').forEach(button => button.addEventListener('click', () => {
      const card = videoRail?.querySelector('article');
      if (!card) return;
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(videoRail).gap || 0);
      videoRail.scrollBy({left: Number(button.dataset.videoStep) * distance, behavior: reduce() ? 'instant' : 'smooth'});
    }));
    const reviews = root.querySelector('.ss-reviews');
    const reviewObserver = reviews && new IntersectionObserver(entries => {
      reviews.dataset.offscreen = String(!entries[0].isIntersecting);
    });
    if (reviews) reviewObserver.observe(reviews);
    const visibilityHandler = () => {
      videos.forEach(video => {
        if (!document.hidden && video.dataset.visible === 'true') playVisible(video);
        else video.pause();
      });
    };
    document.addEventListener('visibilitychange', visibilityHandler);
    document.addEventListener('shopify:section:unload', function cleanup(event) {
      if (!event.target.contains(root)) return;
      videoObserver.disconnect(); reviewObserver?.disconnect();
      document.removeEventListener('visibilitychange', visibilityHandler);
      document.removeEventListener('shopify:section:unload', cleanup);
    });
  }
  document.querySelectorAll('[data-ss-pdp]').forEach(init);
})();
